module.exports = "/images/ai.svg?023a1259179c868adba89a2a172cffca";